import { createFileRoute } from '@tanstack/react-router';

import { requireAdmin } from '@/components/admin/require-admin.ts';
import { StudentListPage } from '@/views/admin/student-list-page.tsx';

export const Route = createFileRoute('/admin/students')({
  beforeLoad: requireAdmin,
  component: StudentListPage,
});
